/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('UserTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		UserTypeFactory,
		FindAllUserTypesByQueryParamsNonPageableFactory,
		NoPagingUserTypeFactory,
		NoPagingPredefinedUserTypeFactory
	) {
		$scope.userTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('usertype.list.new');
		};

		$scope.goToEditState = function(userType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('usertype.list.edit', { userTypeId: userType.id });
		};

		$scope.getUserTypeList = function() {
			FindAllUserTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.userTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getUserTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedUserTypeId = id;
			$('#deleteUserTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserTypeFactory.delete(
				{ id: $scope.selectedUserTypeId },
				function() {
					$scope.loadAll();
					$('#deleteUserTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteUserTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
